import { ApiResponse, Attachment, Meta, TicketManagerComment, User } from '@vision/ui/interfaces';

export interface TicketManagerCommentResponseDto {
  attachments: Attachment[];
  body: string;
  created_at: string;
  id: string;
  ticket_id: string;
  updated_at: string;
  user: Partial<User> | null;
  user_id: string;
}

export interface TicketManagerTicketCommentsResponseEnvelope {
  data?: TicketManagerCommentResponseDto[] | null;
  meta?: Meta | null;
  object: 'collection';
  url?: string;
}

export interface TicketManagerTicketCommentResponseEnvelope {
  data: TicketManagerCommentResponseDto;
  meta?: Meta | null;
  object: string;
  url?: string;
}

function mapTicketManagerComment(dto: TicketManagerCommentResponseDto): TicketManagerComment {
  return {
    attachments: dto.attachments,
    body: dto.body,
    createdAt: dto.created_at,
    id: dto.id,
    ticketId: dto.ticket_id,
    updatedAt: dto.updated_at,
    user: dto.user,
    userId: dto.user_id,
  };
}

export function normalizeTicketManagerTicketCommentsResponse(
  response: TicketManagerTicketCommentsResponseEnvelope,
): ApiResponse<TicketManagerComment[]> {
  return {
    data: Array.isArray(response.data) ? response.data.map(mapTicketManagerComment) : [],
    meta: response.meta ?? null,
    object: 'collection',
  };
}

export function normalizeTicketManagerTicketCommentResponse(
  response: TicketManagerTicketCommentResponseEnvelope,
): ApiResponse<TicketManagerComment> {
  return {
    data: mapTicketManagerComment(response.data),
    meta: response.meta ?? null,
    object: 'object',
    url: response.url,
  };
}
